import { useMemo } from 'react';

import BottomNav from 'components/bottomNav/bottomNav';
import { useAuth } from 'modules/auth/context/AuthContextV2';
import ActivityHeader from './components/header';
import ActivityLayout from './layouts/ActivityLayout';
import ActivityInvites from './components/invites';
import ActivityPolls from './components/poll';
import UserActivities from './components/userActivities';
import dayjs from 'dayjs';
import {
  useGetEventByDateRangeQuery,
  useGetEventsQuery,
  useGetPendingEventsQuery,
} from 'services/event.service';
import { compareDates } from 'modules/letsMeet/utils/dates';

const Activities: React.FC = () => {
  const { user } = useAuth();

  const { data: laterEvents } = useGetEventByDateRangeQuery({
    startDate: dayjs()
      .startOf('week')
      .add(1, 'day')
      .add(0, 'week')
      .format('YYYY-MM-DD'),
    endDate: dayjs()
      .endOf('week')
      .add(1, 'day')
      .add(1, 'year')
      .format('YYYY-MM-DD'),
  });

  const { data: pendingEvents } = useGetPendingEventsQuery({
    page: 0,
    isPast: false,
  });

  const { data: eventData } = useGetEventsQuery();

  const eventDataFiltered = useMemo(() => {
    return eventData?.filter((event: any) => {
      return (
        (event.end ? event.end : event.start) &&
        compareDates(
          dayjs(event.end ? event.end : event.start).toDate(),
          dayjs().toDate(),
        ) &&
        event.contacts.some(
          (contact: any) =>
            contact.userId &&
            contact.userId !== user?._id &&
            contact.status === 1,
        )
      );
    });
  }, [eventData, user]);

  const pollEventsData = useMemo(() => {
    return pendingEvents?.filter((event: any) => {
      return (
        event.type === 'poll' &&
        event.event.contacts.some(
          (contact: any) => contact.userId === user?.id && contact.status === 0,
        )
      );
    });
  }, [pendingEvents, user]);

  const laterEventsData = useMemo(() => {
    return (laterEvents ?? []).filter((event: any) => {
      return event.event.contacts.some(
        (contact: any) => contact.userId === user?.id && contact.status === 0,
      );
    });
  }, [laterEvents, user]);

  // refresh every 3 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getEventActivity();
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);

  if (!user) {
    return null;
  }

  return (
    <ActivityLayout>
      <ActivityHeader user={user} />
      <ActivityInvites invites={laterEventsData ?? []} />
      <ActivityPolls polls={pollEventsData ?? []} />
      <UserActivities activities={eventDataFiltered ?? []} />
      <BottomNav />
    </ActivityLayout>
  );
};

Activities.displayName = 'Activities';
export default Activities;
